// Every user-visible string lives here (ADR-0005). The API speaks English codes;
// the UI renders Portuguese.
export const ptBR = {
  appName: 'Cardápio Lucrativo',
  tagline: 'Custo, margem e preço por canal de venda',
  health: {
    checking: 'Verificando conexão…',
    ok: 'Sistema no ar',
    down: 'Sistema indisponível',
    dbUp: 'Banco de dados: conectado',
    dbDown: 'Banco de dados: sem conexão',
  },
  common: {
    loading: 'Carregando…',
    save: 'Salvar',
    cancel: 'Cancelar',
    edit: 'Editar',
    create: 'Criar',
    actions: 'Ações',
  },
  auth: {
    loginTitle: 'Entrar',
    email: 'E-mail',
    password: 'Senha',
    submit: 'Entrar',
    logout: 'Sair',
  },
  home: {
    myCompany: 'Sua empresa',
    myCompanies: 'Suas empresas',
    noCompany: 'Nenhuma empresa vinculada à sua conta ainda.',
  },
  admin: {
    title: 'Administração',
    goToAdmin: 'Ir para administração',
    nav: {
      tenants: 'Empresas',
      users: 'Pessoas',
      memberships: 'Vínculos',
    },
    tenants: {
      title: 'Empresas',
      name: 'Nome',
      kind: 'Tipo',
      kindOptions: {
        restaurant: 'Restaurante',
        bakery: 'Padaria',
        other: 'Outro',
      },
      createTitle: 'Nova empresa',
    },
    users: {
      title: 'Pessoas',
      name: 'Nome',
      email: 'E-mail',
      password: 'Senha',
      isPlatformAdmin: 'Admin. da plataforma',
      createTitle: 'Nova pessoa',
    },
    memberships: {
      title: 'Vínculos',
      person: 'Pessoa',
      company: 'Empresa',
      role: 'Papel',
      roleOptions: {
        owner: 'Proprietário(a)',
        member: 'Colaborador(a)',
      },
      createTitle: 'Novo vínculo',
    },
  },
  errors: {
    invalid_credentials: 'E-mail ou senha inválidos.',
    email_taken: 'Já existe uma pessoa com este e-mail.',
    membership_exists: 'Esta pessoa já está vinculada a esta empresa.',
    tenant_not_found: 'Empresa não encontrada.',
    user_not_found: 'Pessoa não encontrada.',
    not_platform_admin: 'Você não tem acesso a esta área.',
    not_authenticated: 'Sessão expirada. Entre novamente.',
    validation_error: 'Confira os campos preenchidos.',
    unknown_error: 'Algo deu errado. Tente novamente.',
  },
} as const;

export type Messages = typeof ptBR;

export function errorMessage(code?: string): string {
  const errors: Record<string, string> = ptBR.errors;
  return (code && errors[code]) || ptBR.errors.unknown_error;
}
